import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const LeaveBalanceAlerts = ({ alerts }) => {
  const getSeverityConfig = (severity) => {
    switch (severity) {
      case 'critical':
        return {
          bg: 'bg-error/10',
          border: 'border-error',
          icon: 'AlertTriangle',
          iconColor: 'var(--color-error)',
          text: 'text-error'
        };
      case 'warning':
        return {
          bg: 'bg-warning/10',
          border: 'border-warning',
          icon: 'AlertCircle',
          iconColor: 'var(--color-warning)',
          text: 'text-warning'
        };
      default:
        return {
          bg: 'bg-muted',
          border: 'border-border',
          icon: 'Info',
          iconColor: 'var(--color-muted-foreground)',
          text: 'text-muted-foreground'
        };
    }
  };

  return (
    <div className="bg-card border border-border rounded-md p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="Bell" size={20} color="var(--color-primary)" />
        <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground">
          Leave Balance Alerts
        </h3>
      </div>
      <div className="space-y-3">
        {alerts?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="CheckCircle" size={48} color="var(--color-success)" className="mx-auto mb-3" />
            <p className="caption text-sm text-muted-foreground">No active alerts</p>
          </div>
        ) : (
          alerts?.map((alert) => {
            const config = getSeverityConfig(alert?.severity);
            return (
              <div
                key={alert?.id}
                className={`flex items-start gap-3 p-3 rounded-md border ${config?.bg} ${config?.border} transition-smooth hover:shadow-sm`}
              >
                <div className="flex-shrink-0 mt-0.5">
                  <Icon name={config?.icon} size={18} color={config?.iconColor} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <Image
                      src={alert?.employeeAvatar}
                      alt={alert?.employeeAvatarAlt}
                      className="w-6 h-6 rounded-full object-cover"
                    />
                    <p className="font-body font-medium text-sm text-foreground truncate">
                      {alert?.employeeName}
                    </p>
                  </div>
                  <p className="caption text-xs text-muted-foreground mb-1">
                    {alert?.message}
                  </p>
                  <div className="flex items-center gap-2">
                    <span className={`caption text-xs font-medium ${config?.text}`}>
                      {alert?.leaveType}
                    </span>
                    <span className="caption text-xs text-muted-foreground">•</span>
                    <span className="data-text text-xs text-muted-foreground">
                      {alert?.daysRemaining} days remaining
                    </span>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default LeaveBalanceAlerts;